import type { Locale } from "@/lib/i18n/config";

export interface TranslationSuggestionPayload {
  itemId: string;
  names: Partial<Record<Locale, string>>;
}

/**
 * No backend endpoint exists for this yet — this POSTs to a placeholder route so the UI is
 * ready to go live as soon as one does. Fails gracefully (surfaced via the caller's error
 * state) rather than pretending the suggestion was saved.
 */
export async function submitTranslationSuggestion(payload: TranslationSuggestionPayload): Promise<{ ok: boolean }> {
  try {
    const res = await fetch("/api/translation-suggestions", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    return { ok: res.ok };
  } catch {
    return { ok: false };
  }
}
